import {
  IField_Paginated_Sort_Direction_Ascending,
  IField_Paginated_Sort_Direction_Descending,
  IData_Paginated_Results,
  IData_Paginated_Sort_Descriptor,
} from '../types/pagination'

export const PAGINATION_SORT_DIRECTION_ASCENDING: IField_Paginated_Sort_Direction_Ascending = "ASC"
export const PAGINATION_SORT_DIRECTION_DESCENDING: IField_Paginated_Sort_Direction_Descending = "DESC"

export const PAGINATION_SORT_DIRECTION_DEFAULT = PAGINATION_SORT_DIRECTION_ASCENDING

export const PAGINATION_SORT_DIRECTION = [
  PAGINATION_SORT_DIRECTION_ASCENDING,
  PAGINATION_SORT_DIRECTION_DESCENDING,
]

export const PAGINATION_PAGE_SIZE_DEFAULT = 25
export const PAGINATION_PAGE_SIZE_MAX = 100

export const PAGINATION_RESULTS_DEFAULT: IData_Paginated_Results = {
  pageSize: PAGINATION_PAGE_SIZE_DEFAULT,
  page: 1,
  total: 0,
}

export const PAGINATION_PAGE_SIZE_OPTIONS = [
  10,
  25,
  50,
  100,
]


export const PAGINATION_APPEVENT_SORT_DESCRIPTOR: IData_Paginated_Sort_Descriptor = {
  columns: [
    ['created_at', 'app_event.created_at'],
    ['email', 'user.email'],
    ['org_name', 'org.name'],
    ['type', 'app_event.type'],
  ],
  defaultColumn: 'created_at',
  defaultDirection: 'DESC',
}

export const PAGINATION_CRMEVENT_SORT_DESCRIPTOR: IData_Paginated_Sort_Descriptor = {
  columns: [
    ['created_at', 'crm_event.created_at'],
    ['email', 'crm_contact.email'],
    ['org_name', 'org.name'],
    ['type', 'crm_event.type'],
  ],
  defaultColumn: 'created_at',
  defaultDirection: 'DESC',
}

export const PAGINATION_CRMCONTACT_SORT_DESCRIPTOR: IData_Paginated_Sort_Descriptor = {
  columns: [
    ['created_at', 'crm_contact.created_at'],
    ['email', 'crm_contact.email'],
    ['org_name', 'org.name'],
  ],
  defaultColumn: 'created_at',
  defaultDirection: 'DESC',
}

export const PAGINATION_BOOKING_SORT_DESCRIPTOR: IData_Paginated_Sort_Descriptor = {
  columns: [
    ['date', 'booking.date'],
    ['date_created', 'booking.created_at'],
    //['email', 'crm_contact.email'],
    ['org_name', 'org.name'],
  ],
  defaultColumn: 'date',
  defaultDirection: 'DESC',
}

export const PAGINATION_ASTONISH_CRM_SORT_DESCRIPTOR: IData_Paginated_Sort_Descriptor = {
  columns: [
    ['date', 'astonish_email.created_at'],
    ['email', 'crm_contact.email'],
  ],
  defaultColumn: 'email',
  defaultDirection: 'ASC',
}

export const PAGINATION_ASTONISH_CAMPAIGNS_SORT_DESCRIPTOR: IData_Paginated_Sort_Descriptor = {
  columns: [
    ['date', 'astonish_campaign.created_at'],
  ],
  defaultColumn: 'date',
  defaultDirection: 'DESC',
}

export const PAGINATION_MARKETING_CAMPAIGNS_SORT_DESCRIPTOR: IData_Paginated_Sort_Descriptor = {
  columns: [
    ['date', 'marketing_campaign.created_at'],
  ],
  defaultColumn: 'date',
  defaultDirection: 'DESC',
}

export const PAGINATION_MARKETING_POSTS_SORT_DESCRIPTOR: IData_Paginated_Sort_Descriptor = {
  columns: [
    ['date', 'marketing_post.post_date'],
  ],
  defaultColumn: 'date',
  defaultDirection: 'ASC',
}
